/* eslint-disable prettier/prettier */
export const FIRST_TIME_LOGIN_WARNING = 'You need to be online for the first time login'
export const FIRST_TIME_DEMO_WARNING = 'You need to be online for the first time to start demo mode'
export const OFFLINE_USER_WARNING = 'User doesn\'t exist'
export const OFFLINE_PIN_WARNING = 'Incorrect pin'

export const DELETE_LEAVE_STUDY = 'Want to leave the study'
export const DELETE_REFUSE_TAKE_PART = 'Declined to take part'
